.eo{white-space:nowrap;}